import React from 'react';
import { useDesign } from '../../designs';

interface OrnamentalDividerProps {
  style?: React.CSSProperties;
}

export default function OrnamentalDivider({ style }: OrnamentalDividerProps) {
  const design = useDesign();
  const { ornamentStyle } = design.options;
  const { ornament, ornamentLine } = design.tokens;

  if (ornamentStyle === 'simple-rule') {
    return (
      <div style={{
        height: '1px',
        background: ornamentLine,
        margin: '16px 0',
        ...style,
      }} />
    );
  }

  // diamond-cluster (default) and custom-svg fallback
  const diamondSize = 5;
  const diamondGap = 2;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      margin: '16px 0',
      ...style,
    }}>
      <div style={{
        flex: 1,
        height: '1px',
        background: `linear-gradient(90deg, transparent, ${ornamentLine})`,
      }} />
      <div style={{ display: 'flex', gap: `${diamondGap}px` }}>
        {[0, 1, 2].map((i) => (
          <div key={i} style={{
            width: `${diamondSize}px`,
            height: `${diamondSize}px`,
            backgroundColor: ornament,
            transform: 'rotate(45deg)',
          }} />
        ))}
      </div>
      <div style={{
        flex: 1,
        height: '1px',
        background: `linear-gradient(90deg, ${ornamentLine}, transparent)`,
      }} />
    </div>
  );
}
